import { connect } from "react-redux";
import { Creators, getEditQueueItem } from "../../../reducer";
import EditRegistration from "./EditRegistration";

export default connect(
  state => ({
    editQueueItem: getEditQueueItem(state),
    rangeLocation: state.login.location
  }),
  dispatch => ({
    onSave: (rangeLocation, registrationId, updateRegistration) =>
      dispatch(
        Creators.updateQueueItem(
          rangeLocation,
          registrationId,
          updateRegistration
        )
      )
  })
)(EditRegistration);



// WEBPACK FOOTER //
// ./src/staff/components/QueueItemDrawer/EditRegistration/index.js